import routes from './routes';

/*
 * Product registry for the extranet.
 *
 * The extranet began as a single-product app (endorsement). It now also hosts
 * cargo claims and health claims, so products sit one level
 * above the section links in the header.
 *
 * DEMO: this list is static. In production the products a user can reach come
 * from the user payload, and menu items carry a `product` field so a section
 * cannot leak into the wrong product's nav. See the UI plan, section 7.
 */

export type ProductKey = 'endorsement' | 'cargoClaims' | 'healthClaims';

export interface Product {
  key: ProductKey;
  name: string;
  // Where the switcher sends you when you pick this product.
  path: string;
  // Pathname prefixes owned by this product. Endorsement claims none: it is the
  // fallback, because its section paths predate the product level and were left
  // untouched so existing links keep working.
  basePaths: string[];
}

export const PRODUCTS: Product[] = [
  {
    key: 'endorsement',
    name: 'Endorsement',
    path: routes.main,
    basePaths: [],
  },
  {
    key: 'cargoClaims',
    name: 'Cargo Claims',
    path: `${routes.cargoClaims.index}?page=1&rows=50&first=0&status=All`,
    basePaths: [routes.cargoClaims.index],
  },
  {
    key: 'healthClaims',
    name: 'Health Claims',
    path: `${routes.healthClaims.index}/${routes.healthClaims.dashboard}`,
    basePaths: [routes.healthClaims.index],
  },
];

export function resolveActiveProduct(pathname: string): Product {
  const owned = PRODUCTS.find((product) =>
    product.basePaths.some((base) => pathname.startsWith(base))
  );

  return owned || PRODUCTS[0];
}
